import { Component, inject, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { catchError, forkJoin, of } from 'rxjs';

import { LayoutComponent } from '../../../shared/layouts/layout/layout.component';
import { LayoutService } from '../../../shared/services/layout/layout.service';
import { LoadingService } from '../../../shared/services/loading/loading.service';
import { Event as EventType } from '../../models/events.model';
import { Task } from '../../models/mip/task.model';
import { Ticket } from '../../models/tickets/ticket.model';
import { StatsService } from '../../services/stats/stats.service';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [
    LayoutComponent,
    RouterLink
  ],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent implements OnInit {
  private _statsService = inject(StatsService);
  private _router = inject(Router);
  private _layoutService = inject(LayoutService);
  private _loadingService = inject(LoadingService);

  public openTickets: Ticket[] = [];
  public pendingServices: EventType[] = [];
  public tasks: Task[] = [];

  public ticketsPage: number = 1;
  public servicesPage: number = 1;
  public tasksPage: number = 1;

  ngOnInit() {
    this.loadData();
  }

  get colorScheme(): string {
    return this._layoutService.config.colorScheme;
  }

  private loadData(): void {
    this._loadingService.show();

    forkJoin({
      tickets: this._statsService.getOpenTickets(this.ticketsPage).pipe(
        catchError((error) => {
          console.error('Error cargando tickets:', error);
          return of({ items: [] });
        })
      ),
      services: this._statsService.getPendingServices(this.servicesPage).pipe(
        catchError((error) => {
          console.error('Error cargando servicios:', error);
          return of({ items: [] });
        })
      ),
      tasks: this._statsService.getTasks(this.tasksPage).pipe(
        catchError((error) => {
          console.error('Error cargando tareas:', error);
          return of({ items: [] });
        })
      )
    }).subscribe({
      next: ({ tickets, services, tasks }: any) => {
        this.openTickets = [...this.openTickets, ...tickets.items];
        this.pendingServices = [...this.pendingServices, ...services.items];
        this.tasks = [...this.tasks, ...tasks.items];
      },
      complete: () => {
        this._loadingService.hide();
      }
    });
  }

  loadOpenTickets(page: number = 1): void {
    this._statsService.getOpenTickets(page).subscribe({
      next: (data: any) => {
        const ticketsData = data.items;
        this.openTickets = [...this.openTickets, ...ticketsData];
      },
      error: (error) => {
        console.error(error);
      }
    });
  }

  loadPendingServices(page: number = 1): void {
    const today = new Date();

    const oneMonthAgo = new Date(today);
    oneMonthAgo.setMonth(today.getMonth() - 1);

    const oneMonthAhead = new Date(today);
    oneMonthAhead.setMonth(today.getMonth() + 1);

    this._statsService.getPendingServices(page).subscribe({
      next: (data: any) => {
        const services = data.items;

        // const servicesData = services.filter((service: EventType) => {
        //   const initialDate = new Date(service.initial_date);
        //   const finalDate = new Date(service.final_date);

        //   return initialDate >= oneMonthAgo && finalDate <= oneMonthAhead;
        // });

        // this.pendingServices = [...this.pendingServices, ...servicesData];
        this.pendingServices = [...this.pendingServices, ...services];
      },
      error: (error) => {
        console.error(error);
      }
    });
  }

  loadTasks(page: number = 1): void {
    this._statsService.getTasks(page).subscribe({
      next: (data: any) => {
        const tasksData = data.items;
        this.tasks = [...this.tasks, ...tasksData];
      },
      error: (error) => {
        console.error(error);
      }
    });
  }

  handleNavToServices(): void {
    this._router.navigate(['/services']);
  }

  handleNavToTickets(): void {
    this._router.navigate(['/tracings']);
  }

  handleNavToTasks(): void {
    this._router.navigate(['/']);
  }

  handleRefreshTickets(): void {
    this.ticketsPage += 1;
    this.loadOpenTickets(this.ticketsPage);
  }

  handleRefreshServices(): void {
    this.servicesPage += 1;
    this.loadPendingServices(this.servicesPage);
  }

  handleRefreshTasks(): void {
    this.tasksPage += 1;
    this.loadTasks(this.tasksPage);
  }
}
